// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2NN65","title":"Images90_title__2gwn0","images":"Images90_images__29Zr8"};